// extracted by mini-css-extract-plugin
export var button = "EmployeeView-module--button--fd42f";
export var cmsImage = "EmployeeView-module--cmsImage--21790";
export var description = "EmployeeView-module--description--74689";
export var employee = "EmployeeView-module--employee--4f456";
export var imageWrapper = "EmployeeView-module--imageWrapper--1a1ca";
export var name = "EmployeeView-module--name--1a81b";
export var nameWrapper = "EmployeeView-module--name-wrapper--19f87";
export var role = "EmployeeView-module--role--d57f7";
export var showDescOnHover = "EmployeeView-module--showDescOnHover--04b78";
export var showMore = "EmployeeView-module--showMore--5dfdf";